module.exports = __webpack_public_path__ + "static/media/image73.14ab275f.png";